export const getMarkingCard = (data) => `
 <div class="ticket_container">
        <div class="section header">
          <div class="header_items_wrapper">
            <img class="logo" alt="logo" />
          </div>
        </div>

        <div class="section numberRequest">
          <p class="bold numberRequest_text">${data.orderNumber}</p>
        </div>

        <div class="section cityTo">
          <div class="cityTo_items_wrapper">
            <img class="cityToArrow" alt="arrow" />
            <p class="cityTo_text bold">В ${data.cityTo}</p>
          </div>
        </div>

        <div class="section receiver">
          <div class="receiver_phoneInfo">
            <p class="receiver_phoneInfo_receiver">Получатель</p>
            <div class="receiver_phoneInfo_phone">
              <img class="receiver_phoneInfo_phone_icon" alt="phone" />
              <p>${data.consigneePhone}</p>
            </div>
          </div>
          <div class="receiver_name bold">${data.consigneeName}</div>
        </div>

        <div class="section address">
          <p class="address_label">
            Адрес <br />
            доставки:
          </p>
          <p class="address_info bold">${data.deliveryAddress}</p>
        </div>

        <div class="section storage">
          <div class="storage_firstColumn">
            <div class="storage_firstColum_seats">
              <p class="storage_firstColum_seats_label">Мест</p>
              <p class="storage_firstColum_seats_amount bold">${data.cargosCount}</p>
            </div>
            <table class="storage_firstColumn_location">
              <tr>
                <td>${data.cargoInfo[0]}</td>
                <td>${data.cargoInfo[1]}</td>
              </tr>
              <tr>
                <td>${data.cargoInfo[2]}</td>
                <td>${data.cargoInfo[3]}</td>
              </tr>
            </table>
          </div>
          <div class="storage_secondColumn">
            <img style="content: ${data.qrString}" alt="qr" />
            <p class="shortCargoId">${data.shortCargoId}</p>
          </div>
        </div>
        <div class="section sender">
          <p class="sender_city">Отправитель: г. ${data.cityFrom}</p>
          <p class="sender_place bold">${data.senderName}</p>
        </div>

        <div class="section newInfo">
            <div class="newInfo_header">
              <div class="newInfo_header_main">
                <img class="fireImg" alt="fire" />
                <div>
                  <p><span>ОФОРМИ  ДОПОЛНИТЕЛЬНУЮ</span></p>
                  <p><span>УПАКОВКУ ДЛЯ ГРУЗА</span></p>
                </div>
              </div>
              <p class="newInfo_data_extraInfo"><span>Подробнее на тк-луч.рф</span></p>
            </div>
        </div>
      </div>`;
